import React from 'react';

interface LogoProps {
    className?: string;
}

export const Logo: React.FC<LogoProps> = ({ className = '' }) => {
    return (
        <div
            className={`flex items-center gap-3 ${className}`}
            role="img"
            aria-label="VoxPop AI"
        >
            <div className="relative flex items-center justify-center w-12 h-12">
                <svg
                    viewBox="0 0 100 65"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-full h-full drop-shadow-md"
                >
                    <defs>
                        <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                            <stop offset="0%" stopColor="#4f46e5" /> {/* Indigo-600 */}
                            <stop offset="50%" stopColor="#7c3aed" /> {/* Violet-600 */}
                            <stop offset="100%" stopColor="#a855f7" /> {/* Purple-500 */}
                        </linearGradient>
                    </defs>

                    {/* Chat Bubble Body with tail */}
                    <path
                        d="M10,5 H80 A10,10 0 0,1 90,15 V45 A10,10 0 0,1 80,55 H30 L15,65 V55 H10 A10,10 0 0,1 0,45 V15 A10,10 0 0,1 10,5 Z"
                        fill="url(#logoGradient)"
                    />

                    {/* Pulse Line (White) - EKG style */}
                    <path
                        d="M5,30 H35 L40,15 L50,45 L55,30 H65"
                        stroke="white"
                        strokeWidth="4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />

                    {/* Red/Pink Dot Pulse Effect - kept energetic but slightly pinker to match purple */}
                    <circle cx="55" cy="30" r="3" fill="#f43f5e" className="animate-pulse" /> {/* Rose-500 */}
                    <circle cx="55" cy="30" r="6" stroke="#f43f5e" strokeWidth="1" className="animate-ping opacity-75" />

                    {/* Speed Lines - Lighter purple/indigo */}
                    <path d="M75,30 H95" stroke="#c084fc" strokeWidth="4" strokeLinecap="round" /> {/* Purple-400 */}
                    <path d="M80,20 H90" stroke="#c084fc" strokeWidth="4" strokeLinecap="round" />
                    <path d="M80,40 H98" stroke="#c084fc" strokeWidth="4" strokeLinecap="round" />
                </svg>
            </div>
            <span className="text-xl font-bold text-slate-900 dark:text-white font-heading tracking-tight">
                VoxPop <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-purple-600">AI</span>
            </span>
        </div>
    );
};
